import _ from 'underscore';
import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

const SERIALIZED_PROPS: Array<keyof AuthoringPartnerStore$DehydratedState> = [
  'saveInProgress',
  'currentPartner',
  'cachedPartner',
];

type AuthoringPartnerStore$DehydratedState = {
  saveInProgress?: boolean;
  currentPartner: any;
  cachedPartner: any;
};

class AuthoringPartnerStore extends BaseStore {
  declare saveInProgress?: boolean;

  declare currentPartner: any;

  declare cachedPartner: any;

  declare emitChange: () => void;

  static storeName = 'AuthoringPartnerStore';

  static handlers = {
    RECEIVE_CURRENT_PARTNER: 'onReceiveCurrentPartner',
    // updates the partner object that exists on the client side
    UPDATE_CURRENT_PARTNER: 'onUpdateCurrentPartner',
    // start to save the partner
    SAVE_PARTNER_START: 'onSavePartnerStart',
    // partner has finished saving on the BE, update the cached partner in the FE
    SAVE_PARTNER_SUCCESS: 'onSavePartnerSuccess',
    SAVE_PARTNER_FAILED: 'onSavePartnerFailed',
  };

  onReceiveCurrentPartner(partner: { partner: any }) {
    this.currentPartner = partner;
    this.cachedPartner = partner;
    this.emitChange();
  }

  onUpdateCurrentPartner(partner: { partner: any }) {
    this.currentPartner = partner;
    this.emitChange();
  }

  onSavePartnerStart() {
    this.saveInProgress = true;
    this.emitChange();
  }

  onSavePartnerSuccess() {
    this.saveInProgress = false;
    this.cachedPartner = this.currentPartner; // save deep copy of partner in the cache
    this.emitChange();
  }

  onSavePartnerFailed() {
    this.saveInProgress = false;
    this.emitChange();
  }

  dehydrate(): AuthoringPartnerStore$DehydratedState {
    return _(this).pick(...SERIALIZED_PROPS);
  }

  rehydrate(state: AuthoringPartnerStore$DehydratedState) {
    Object.assign(this, _(state).pick(...SERIALIZED_PROPS));
  }

  initialize() {
    this.saveInProgress = false;
  }

  getId() {
    return this.currentPartner.id;
  }

  getCurrentPartner() {
    return this.currentPartner;
  }

  getCachedPartner() {
    return this.cachedPartner;
  }

  hasUnsavedChanges() {
    return this.currentPartner !== this.cachedPartner;
  }

  isSaveInProgress() {
    return this.saveInProgress;
  }
}

export default AuthoringPartnerStore;
